import axios from 'axios';
import {
  extractCompanyLogo,
  extractTenantTemplateType,
  normalizeAppletId,
  persistAppletId,
  readCachedAppletId,
  type AppletId,
} from './appletRegistry';

import { getLoginApiBaseUrl } from './loginApiBase';

export type TenantBootResult = {
  appletId: AppletId;
  templateType: string | null;
  companyLogo: unknown;
  companyName: string | null;
  raw: Record<string, any> | null;
};

/**
 * Same contract as arva branch: GET /api/auth/tenant/
 * Backend resolves company from Origin/Referer.
 */
export async function fetchTenantForApplet(): Promise<TenantBootResult> {
  try {
    const response = await axios.get(`${getLoginApiBaseUrl()}/api/auth/tenant/`, {
      timeout: 30000,
      headers: { 'Content-Type': 'application/json' },
    });
    const data = response.data || {};
    const templateType = extractTenantTemplateType(data);
    const appletId = normalizeAppletId(templateType);
    const companyLogo = extractCompanyLogo(data);
    const companyName = data.company?.name || data.company_name || null;

    const normalized = {
      ...data,
      template_type: templateType,
      company_name: companyName,
      company_logo: companyLogo,
    };

    try {
      localStorage.setItem('tenant_config', JSON.stringify(normalized));
      sessionStorage.setItem('nsight_shell_tenant_boot', '1');
    } catch {
      // non-critical
    }

    persistAppletId(appletId);

    return {
      appletId,
      templateType,
      companyLogo,
      companyName,
      raw: normalized,
    };
  } catch (error) {
    console.error('Shell: failed to fetch tenant config', error);
    return {
      appletId: readCachedAppletId(),
      templateType: null,
      companyLogo: null,
      companyName: null,
      raw: null,
    };
  }
}
